import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/global.css';
import { App } from './App';
import { initSentry, SentryErrorBoundary } from './lib/sentry';

// Initialize Sentry BEFORE React renders so the ErrorBoundary is wired and
// any synchronous render-time error is captured. No-op when VITE_SENTRY_DSN
// is unset or when MODE is development/test — see lib/sentry.ts.
initSentry();

const root = document.getElementById('root');
if (!root) {
  throw new Error('Missing #root element in index.html');
}
createRoot(root).render(
  <StrictMode>
    {/*
      ErrorBoundary catches React render-tree exceptions and reports them to
      Sentry. The fallback intentionally renders raw text rather than the
      app's normal UI — a render-time crash means React's normal styling /
      state machinery is suspect. Plain HTML keeps the recovery affordance
      simple.
    */}
    <SentryErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: 32, fontFamily: 'system-ui, sans-serif' }}>
          <h1>Something went wrong.</h1>
          <p>
            The console hit an unexpected error and the issue has been reported.
            Refresh the page to try again.
          </p>
          <pre
            style={{
              padding: 16,
              background: '#1a1a1a',
              color: '#eee',
              borderRadius: 4,
              overflow: 'auto',
              maxWidth: 720,
            }}
          >
            {error instanceof Error ? error.message : String(error)}
          </pre>
          <button
            onClick={resetError}
            style={{ marginTop: 12, padding: '8px 16px' }}
          >
            Try again
          </button>
        </div>
      )}
    >
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
);
